import { gql } from "@apollo/client";export default gql`query studentAggregate($where: student_bool_exp) {
    studentAggregate: student_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
